import { EmailSetup } from '../components/email-advanced-settings/email-advanced-settings.component';
import { ImageBlock } from '../blocks/image-block/image-block.component';
import { RichTextBlock } from '../blocks/rich-text-block/rich-text-block.component';
import { HeadingBlock } from '../blocks/heading-block/heading-block.component';
import { ButtonBlock } from '../blocks/button-block/button-block.component';
import { DividerBlock } from '../blocks/divider-block/divider-block.component';
import { SpacerBlock } from '../blocks/spacer-block/spacer-block.component';
import { HtmlBlock } from '../blocks/html-block/html-block.component';
import { ContactCard } from '../blocks/contact-card/contact-card.component';
import { SimpleTableBlock } from '../blocks/simple-table-block/simple-table-block.component';
import { ImageAndTextBlock } from '../blocks/image-and-text-block/image-and-text-block.component';
import { ReviewRequestLinksBlock } from '../blocks/review-request-links-block/review-request-links-block.component';
import { NetPromoterScoreBlock } from '../blocks/nps-block/nps-block.component';

export type blockType =
  | 'image'
  | 'rich_text'
  | 'heading'
  | 'button'
  | 'contact_card'
  | 'image_and_text'
  | 'simple_table'
  | 'divider'
  | 'spacer'
  | 'html'
  | 'add_new_block'
  | 'suggest_content'
  | OptionalBlockIds;

export type contentBlockInterfaces =
  | ImageBlock
  | RichTextBlock
  | HeadingBlock
  | ButtonBlock
  | ImageAndTextBlock
  | SimpleTableBlock
  | ContactCard
  | DividerBlock
  | SpacerBlock
  | HtmlBlock
  | OptionalBlockInterfaces;

export interface EmailContentData {
  id?: string;
  name?: string;
  subjectLine?: string;
  previewText?: string;
  author?: string;
  lastModified?: string;
  emailSetup: EmailSetup;
  emailContentBlocks: ContentListItem[];
  basicSetupValid?: boolean;
}

export interface ContentListItem {
  type: blockType;
  renderType?: blockType;
  content?: contentBlockInterfaces;
  showPadding?: boolean;
  padding?: {
    top?: number;
    bottom?: number;
  };
  collapsed?: boolean;
  valid?: boolean;
}

export const blankContentListItem: ContentListItem = {
  type: null,
  renderType: null,
  showPadding: false,
  padding: {
    top: null,
    bottom: null,
  },
  collapsed: false,
};

export interface BlockNamesAndIconsType {
  id: string;
  renderType?: string;
  name: string;
  icon: string;
  dividerAfter?: boolean;
}

export const defaultBlockChoices: BlockNamesAndIconsType[] = [
  {
    id: 'image',
    name: 'Image',
    icon: 'image',
  },
  {
    id: 'heading',
    name: 'Heading',
    icon: 'text_fields',
  },
  {
    id: 'rich_text',
    name: 'Rich Text',
    icon: 'subject',
  },
  {
    id: 'suggest_content',
    name: 'Generate Content',
    icon: 'galaxy-ai-icon',
  },
  {
    id: 'button',
    name: 'Button',
    icon: 'crop_7_5',
    dividerAfter: true,
  },
  {
    id: 'image_and_text',
    name: 'Image and Text',
    icon: 'vertical_split',
  },
  {
    id: 'contact_card',
    name: 'Contact Card',
    icon: 'recent_actors',
  },
  {
    id: 'simple_table',
    name: 'Simple Table',
    icon: 'border_all',
    dividerAfter: true,
  },
  {
    id: 'divider',
    name: 'Divider',
    icon: 'remove',
  },
  {
    id: 'spacer',
    name: 'Spacer',
    icon: 'space_bar',
    dividerAfter: true,
  },
  {
    id: 'html',
    name: 'Raw Html',
    icon: 'code',
    dividerAfter: true,
  },
];

// =========================================================================
// ============================ Optional Blocks ============================
// =========================================================================

export type OptionalBlockIds = 'review_request_links' | 'net_promoter_score';
export type OptionalBlockInterfaces = ReviewRequestLinksBlock | NetPromoterScoreBlock;

export interface OptionalBlockNamesAndIconsType extends BlockNamesAndIconsType {
  // we only need to change the id to OptionalBlockTypes, and will leave the rest as is
  id: OptionalBlockIds;
}

export const optionalBlockTypes: OptionalBlockNamesAndIconsType[] = [
  {
    id: 'review_request_links',
    renderType: 'html',
    name: 'Review Request Links',
    icon: 'rate_review',
  },
  {
    id: 'net_promoter_score',
    renderType: 'html',
    name: 'NPS',
    icon: 'rate_review',
  },
];
